/**
 * Design-wise
 * Legacy JS for Terms section
 */

import DesignWise from './components/_designwise';
import Nav from './components/_nav';
import Vids from './components/_vids';

DesignWise.init();

Nav.selectNav('#dw_mobile');
Nav.nav();

Vids(document.querySelector('#term_window'));



// WEBPACK FOOTER //
// ./designwise.js